import script from "./TgLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./TgLogin.vue?vue&type=script&setup=true&lang=js"

import "./TgLogin.vue?vue&type=style&index=0&id=972f916e&lang=scss&scoped=true"

import exportComponent from "/home/dima/Work/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-972f916e"]])

export default __exports__